import React from 'react';
import './terms.css';

export default function Terms() {
  return (
    <div className='container-fluid nopadding marg-top-for-transparent-header'>
      <div className='row'>
        <div className='col-sm-1'></div>
        <div className='col-sm-10'>
          <section className='terms-section'>
            <h1>
              <b>Rightdevice Terms and Conditions</b>
            </h1>
            <p>
              <b>Effective Date: 05/19/2026</b>
            </p>
            <p>
              Please read these Rightdevice Terms and Conditions ("Terms") carefully. These Terms are entered into
              between you and Rightdevice, Inc. d/b/a PatientPartner ("Rightdevice," "we" or "our"). As used in these
              Terms, "you" and "your" refer to anyone accessing the Site (as defined below), including Rightdevice
              community members, mentors, health care providers, and individuals participating as a mentee under the
              PatientPartner mentor program ("Mentee").
            </p>
            <p>
              These Terms govern your use of the website at www.patientpartner.com, along with the services and
              information available through the website, through chat, through video or audio communications, through
              your participation by any means as a Mentee under the PatientPartner mentor program, and through any
              Rightdevice app (each and collectively, the "Site"). These Terms apply whether you access the Site from a
              computer, mobile device, or tablet.
            </p>
            <p>
              By accessing or using the Site, registering for a Service Account with Rightdevice, registering your
              participation as a Mentee under the PatientPartner program, or clicking the "Submit" button, you accept
              and agree to be bound by these Terms, the Rightdevice Privacy Policy, the Code of Conduct, and any other
              policies in effect at that time. If you do not agree to these Terms or any other Rightdevice policies, do
              not register for a Service Account, access or use the Site, or register your participation as a Mentee
              under the PatientPartner program.
            </p>
            <p>
              If applicable, as a condition of your participation as a Mentee under the PatientPartner program, you
              agree to execute the Mentee Consent Form provided to you by Rightdevice.
            </p>
            <p>
              "Mentor" means an individual who has been screened, trained, and approved by Rightdevice to participate in
              the PatientPartner program based on their personal experience with a specific medical condition,
              treatment, procedure, or therapy. Mentors share their personal experiences with Mentees for peer support
              and informational purposes only. Mentors are not health care providers acting in a clinical capacity, and
              any guidance, opinions, or information shared by a Mentor does not constitute medical advice, diagnosis,
              or treatment.
            </p>
            <p>
              <b>1. Modification</b>
            </p>
            <p>
              Rightdevice reserves the right to make changes to the Site, these Terms and other policies. If Rightdevice
              makes material changes to these Terms or other policies, then Rightdevice will either notify you by email
              or by posting a notice on the Site prior to the effective date of the changes. Rightdevice will also
              indicate at the bottom of this page the date these Terms were last updated. These Terms are effective upon
              acceptance by new users. For current users, these Terms are effective as of May 1, 2026 and supersede all
              previous versions of the Rightdevice Terms and Conditions and similar agreements. If any section or
              portion of these Terms shall be deemed invalid, void, or for any reason unenforceable, then that section
              of the Terms shall be deemed severable and shall not affect the validity of the remaining conditions. Your
              continued use of the Site after any such changes are posted constitutes your acceptance of the new Terms.
              If you do not agree to abide by these or any future terms, you may not use or access the Site.
            </p>
            <p>
              <b>2. No Medical Advice</b>
            </p>
            <p>
              The Content (which includes any text, graphics, audio, images, video, communications, or other materials)
              contained, accessed, or entered on the Site, or with respect to your participation as Mentee under the
              PatientPartner program by you, any Mentor, healthcare provider, or other users (the "Content") is for
              educational and informational purposes only and does not constitute and is not in any way a substitute for
              medical advice, diagnosis or treatment from a licensed or qualified healthcare professional. Any
              communication between you and others (including Mentors, healthcare providers, or other users) through the
              Site, including responses to questions or interactions through chat, phone calls, video, audio, automated
              tools, or avatars, are provided for general informational purposes only. Such communications do not
              establish and are not intended to establish a physician-patient, provider-patient, fiduciary, or other
              professional relationship under applicable law.
            </p>
            <p>
              Mentors are not licensed healthcare providers, and any support provided by Mentors is peer-based and
              non-clinical in nature. Your reliance on any information (including any links to third-party websites
              containing any information about healthcare providers) or Content made available through the Site, whether
              or not it is provided by a Mentor, healthcare provider, third party, or otherwise, is solely at your own
              risk. You should always seek the advice of your personal healthcare provider for any questions you may
              have about your own medical condition. Never disregard professional medical advice or delay seeking
              medical treatment because of information obtained through the Site. If you believe you are experiencing a
              medical emergency, call 911 or your local emergency number immediately.
            </p>
            <p>
              <b>3. How and When You May Use the Site</b>
            </p>
            <p>
              You may use the Site only to: (i) post messages, comments, reviews, photos, or videos based on your own
              personal experiences; (ii) communicate with Mentors and other community members regarding personal care,
              experiences, or wellness; and (iii) submit questions and feedback through features made available on the
              Site. You may only use the Site solely for your personal, non-commercial uses, and you may not use the
              Site for any commercial, promotional, or business purposes. Without limiting the foregoing, you may not
              use the Site to advertise, promote, market, solicit, endorse, or otherwise publicize any product, service,
              procedure, business, healthcare provider, organization, or individual. You agree not to use the Site to
              collect or harvest personal information of other users, send unsolicited communications, impersonate
              another individual, or misrepresent your affiliation with any person or entity.
            </p>
            <p>
              <b>4. Service Account Eligibility and Authority</b>
            </p>
            <p>
              The Site, including the PatientPartner mentor program, is intended for individuals who are at least
              eighteen (18) years old or the age of majority in their jurisdiction of residence. By accessing or using
              the Site or registering for a Service Account, you represent and warrant that you meet this requirement.
            </p>
            <p>
              If you are accessing or using the Site on behalf of another individual, you represent and warrant that you
              have the legal authority to bind that individual to these Terms and that you will comply with these Terms
              on their behalf.
            </p>
            <p>
              <b>5. Your Service Account; Email Consent</b>
            </p>
            <p>
              In order to use some of the features on the Site, you are required to register and provide information
              about yourself to us and create a Service Account ("Service Account"). It is your responsibility to
              maintain the confidentiality of your Service Account information, including your Service Account password.
              You agree to notify Rightdevice immediately of any unauthorized access to or use of your Service Account.
              In addition, you are responsible for all activities that occur in connection with your Service Account.
              You must tell us right away about anyone using your Service Account without your consent, or any security
              breach that relates to the Site or your Service Account. You agree to provide Rightdevice with accurate,
              current and complete information about yourself as may be prompted in any registration forms on the Site
              and promptly update any such information to keep it accurate, current and complete.
            </p>
            <p>
              Rightdevice reserves the right to refuse to provide services to anyone, including terminating your Service
              Account or restricting access to the Site or your Service Account, at any time, with or without cause or
              notice, in its sole discretion. By using the Site, you consent to receive emails from Rightdevice, which
              may include commercial emails provided such emails are in accordance with the preferences you select in
              the email and notifications page of the My Profile section of the Site. To the extent permitted by law,
              you consent to receive transactional, account-related, and, where applicable, marketing communications
              from Rightdevice. You may change such preferences by changing your account settings on the email and
              notifications page of the My Profile section of the Site or via the unsubscribe link in all commercial
              emails. Please note that as long as you maintain a Service Account, you may not "opt out" of receiving
              service or account-related emails from Rightdevice and all agreements, notices, disclosures, and other
              communications that we provide to you electronically satisfy any legal requirement that such
              communications be in writing.
            </p>
            <p>
              <b>6. Materials You Post or Provide; Communications Monitoring</b>
            </p>
            <p>
              You may be able to post or submit reviews, comments, questions, direct messages, photographs, videos
              (including videos created through a third-party tool), participate in audio calls, and other materials on
              or through the Site (collectively, "Submission" or "Submissions"). Your Submissions, (including to the
              extent applicable, personally identifiable information), are made voluntarily and are subject to these
              Terms, the Code of Conduct, and the Privacy Policy. Except as otherwise provided under applicable law,
              including but not limited to the California Confidentiality of Medical Information Act ("CMIA") and the
              federal Health Insurance Portability and Accountability Act of 1996 (as amended) ("HIPAA"), you understand
              Rightdevice is not obligated to treat any of your Submissions as confidential. In addition, you understand
              and agree that your Submissions (including your username and any profile information you choose to make
              visible, associated with your Submissions) are not confidential and may be publicly available for anyone
              to view on the Site. Rightdevice does not claim ownership of the Submission(s) you post or submit on the
              Site as a Mentee. With the exception of any information you directly submit through a healthcare
              provider's profile or inquiry form, by posting or otherwise providing your Submission on the Site, you are
              hereby expressly granting Rightdevice a non-exclusive, irrevocable, worldwide, perpetual, royalty-free,
              transferable license (including sublicense) to use, host, store, reproduce, translate, copy, distribute,
              publicly display, publicly perform, modify (including create derivative works) or transmit (including
              digital transmission of a sound recording) your Submission, in connection with the Site and the
              Rightdevice business, including without limitation promoting, improving, and redistributing part or all of
              the Site or the Rightdevice business, in any media formats and through any media channels now known or
              hereafter developed. You also grant Rightdevice permission to publish and use your name, likeness, and
              voice in connection with your Submission.
            </p>
            <p>
              It is agreed that Rightdevice owns all anonymized metadata and data that is either not identifiable to you
              or made not identifiable by modification (each and collectively "Anonymized Data"), and any original forms
              or modifications thereof, and that Rightdevice may input into or use as input Anonymized Data into or
              train machine learning and artificial intelligence models for the benefit of Rightdevice and Rightdevice's
              customers (including without limitation for clinical trial design by Rightdevice's customers), as well as
              its platforms and software. In addition, with respect to any Anonymized Data, to the extent not owned by
              Rightdevice, you hereby grant to Rightdevice a royalty-free, perpetual, irrevocable, assignable,
              transferable, non-exclusive right and license for Rightdevice to adopt, publish, reproduce, disseminate,
              transmit, distribute, copy, use, create, Anonymized Data and any derivative works, and display (in whole
              or in part) worldwide, or act on such Anonymized Data without additional approval or consideration, in any
              form, media, or technology now known or later developed for the full term of any rights that may exist in
              such content, and you hereby waive any claim to the contrary. In addition, by uploading a Submission to
              the Site, you hereby waive any rights of privacy or publicity, with the exception of those rights of
              privacy that may be provided to You under applicable laws, state and federal, laws such as CMIA or HIPAA.
              You also grant Rightdevice the right to grant any of the above rights to other persons or entities,
              including for the purpose of promoting the Site or the Rightdevice business, without any compensation or
              obligation to you. You also grant Rightdevice the right and authority to send takedown notices (on your
              behalf) related to your Submission to any individual or entity under the Digital Millennium Copyright Act.
              Rightdevice will not pay you for your Submission. You also understand and agree that Rightdevice may, in
              its sole discretion, refuse, or remove part or all of your Submission from the Site at any time if
              Rightdevice considers the Submission to be illegal, offensive, harassing, infringing, inappropriate or
              otherwise violates these Terms or the Rightdevice Privacy Policy, Code of Conduct, or other policies.
            </p>
            <p>
              For each Submission, you represent and warrant that you have all rights necessary for you to post or
              submit the Submission and to grant the licenses and permissions in this section and that you are solely
              responsible for the content of your Submission. Further, you represent and warrant that your Submission
              does not violate any law. Rightdevice reserves the right to review and monitor Submissions but is under no
              obligation to do so. Rightdevice may, but is not obligated to, monitor, review, report, screen, edit, or
              remove Submissions at its sole discretion. In addition, Rightdevice is not responsible for screening,
              monitoring or editing Submissions. However, we may monitor your Submissions and may disclose information
              about you, including the contents of such Submission, if we deem it necessary to:
            </p>
            <ol>
              <li>Conform to legal requirements or respond to legal process.</li>
              <li>
                Identify, investigate, document, and report safety information, including adverse events, product
                complaints, special situations, or other reportable information, to pharmaceutical manufacturers,
                sponsors, regulatory authorities (including the U.S. Food and Drug Administration), or other appropriate
                entities as required by applicable law or contractual obligations.
              </li>
              <li>Ensure your compliance with these Terms or other Rightdevice guidelines or policies.</li>
              <li>
                Protect the rights, property, or interests of Rightdevice, its employees, its users, or the public.
              </li>
            </ol>
            <p>
              You acknowledge and agree that if you submit information that may constitute an adverse event, product
              complaint, or other reportable safety information, Rightdevice may contact you to obtain additional
              details and may disclose such information, including personal information, as required for regulatory
              reporting purposes. Rightdevice does not provide medical evaluation or assessment of adverse events and
              does not guarantee that any information submitted through the Site will be reported unless required under
              applicable law or contractual obligation.
            </p>
            <p>
              You may also request information directly from a specific healthcare provider by submitting an inquiry
              through their profile or inquiry form. You understand these requests, including personally identifiable
              information, are made voluntarily and are subject to the Rightdevice Privacy Policy. There is no guarantee
              that a healthcare provider will respond to any request submitted through their profile or inquiry form. In
              addition, by submitting a request to a healthcare provider through the Site, you understand that
              Rightdevice may contact you by phone, email or text message about your request. All standard message and
              data charges will apply to any text messages.
            </p>
            <p>
              <b>PRIVACY POLICY.</b>
            </p>
            <p>
              Your participation and access through the Site may require you to submit certain personally identifiable
              information. As a result, you agree to comply with the Privacy Policy contained herein and at{' '}
              <a href='https://www.patientpartner.com/privacy'>https://www.patientpartner.com/privacy</a>.
            </p>
            <p>
              You may opt out of certain communications as referenced in the Privacy Policy by emailing to:{' '}
              <a href='mailto:contact@patientpartner.com'>contact@patientpartner.com</a>.
            </p>
            <p>
              <b>7. Copyright Policy</b>
            </p>
            <p>
              If you believe that your Content or any other Content has been used in a way that constitutes copyright
              infringement, or your intellectual property rights have been otherwise violated, please notify
              Rightdevice, Inc. at contact@patientpartner.com or Copyright Agent, Rightdevice, Inc., 1025 Prospect
              Street #350, La Jolla, CA 92037. To submit a valid notice under the Digital Millennium Copyright Act
              ("DMCA"), please provide all the following information in writing:
            </p>
            <ol>
              <li>
                Identify the copyrighted work you claim has been infringed, or if multiple copyrighted works, then a
                representative list of such works on the Site;
              </li>
              <li>
                Identify the material on the Site that you claim is infringing and provide enough detail so that we may
                locate the material;
              </li>
              <li>
                Provide a statement that you have a good faith belief that the use of the material on the Site is not
                authorized by the copyright owner, its agent, or the law;
              </li>
              <li>
                Provide a statement declaring that the notification is accurate, and, under penalty of perjury, that you
                are the owner of the copyright interest involved or that you are authorized to act on behalf of the
                exclusive owner;
              </li>
              <li>
                Provide information reasonably sufficient to permit Rightdevice to contact you, such as an address,
                telephone number, and email address; and
              </li>
              <li>Your physical or electronic signature.</li>
            </ol>
            <p>
              Upon receipt of a compliant DMCA notice, Rightdevice will take whatever action, in its sole discretion, it
              deems appropriate, including removal of the alleged infringing material from the Site.
            </p>
            <p>
              <b>8. Photograph/Video Policy.</b>
            </p>
            <p>
              If you upload, submit, or post any photograph or video of yourself, you acknowledge and agree that such
              content may be publicly displayed on the Site and used by Rightdevice in accordance with the license
              granted in Section 6. Additionally, if you upload, submit, or post any photograph or video that includes
              another individual, you represent and warrant that you have obtained all necessary rights, permissions,
              and consents required by applicable law to do so. You further represent and warrant that your upload or
              submission does not violate these Terms, the Code of Conduct, or any applicable law, including applicable
              privacy or publicity laws.
            </p>
            <p>
              By submitting a photograph or video that includes your name, image, likeness, voice, or other identifying
              characteristics, you grant Rightdevice the right to use such content as described in Section 6, including
              for promotional, marketing, educational, or operational purposes in connection with the Site and
              Rightdevice's services. You may not upload or share photographs or videos that contain protected health
              information of another individual unless you are legally authorized to do so. You also agree to indemnify
              and hold harmless Rightdevice and the Rightdevice parties against any third-party claims arising out or
              related to the uploading or submitting of any videos or photographs by you or anyone affiliated with you
              (including an agent, employee of your practice, or other third party acting on your behalf).
            </p>
            <p>
              <b>9. Rightdevice Advertising</b>
            </p>
            <p>
              If you purchase advertising from Rightdevice on the Site, then a new applicable agreement or terms of use
              will apply to you in addition to these Terms.
            </p>
            <p>
              <b>10. Links to Other Websites</b>
            </p>
            <p>
              The Site and the Rightdevice app may contain links to other websites maintained by third parties ("Third
              Party Website"), or you may be able to log into the Site or the Rightdevice App through a Third-Party
              Website. Third Party Websites are not owned or controlled by Rightdevice, and Rightdevice does not endorse
              or assume any responsibility for the content, privacy practices, information, or functionality of any
              Third-Party Website. As a result, your access or use of any Third-Party Website is at your own risk, and
              these Terms, the Rightdevice Privacy Policy, Code of Conduct, and any other Rightdevice policies do not
              apply or govern any Third-Party Website or your use of any Third-Party Website. You expressly relieve
              Rightdevice of any and all liability related to the functionality, content or information contained on any
              Third-Party Website. In addition, your dealings with or participation in promotions of third parties found
              on the Site, including payment and delivery of goods or services any other terms (such as warranties,
              representations, or conditions) are solely between you and the third parties. You agree that Rightdevice
              shall not be responsible for any loss or damage of any kind relating to your dealings with such third
              parties. Rightdevice is not responsible for any data collection, use, or disclosure practices of
              Third-Party Websites. You should review the privacy policies and terms of such Third-Party Websites before
              providing any information.
            </p>
            <p>
              <b>11. Rightdevice Intellectual Property Rights</b>
            </p>
            <p>
              Rightdevice grants you a limited, personal, revocable, non-assignable, and nonexclusive license to use the
              Site. Rightdevice owns the text, photographs, videos, visual interfaces, interactive features, graphics,
              design, compilation, computer code, products, software, and all other elements and components of the Site
              ("Rightdevice Content"), excluding, as addressed in Section 6 of this Agreement, your Content and
              community members' Submissions. Rightdevice owns the copyrights, trademarks, service marks, trade names,
              and other intellectual property and proprietary rights throughout the world associated with the
              Rightdevice Content and the Site, which are protected by copyright, trade dress, patent, trademark laws
              and all other applicable intellectual and proprietary rights and laws. You may not modify, reproduce,
              republish, frame, download, transmit, distribute, rent, lease, loan, sell, assign, license, sublicense,
              reverse engineer, publicly display, or create derivative works based on any of the Rightdevice Content in
              whole or in part, or the Site, except as expressly authorized in writing by Rightdevice. You may not use
              any automated means, including bots, scrapers, or data-mining tools, to access, collect, or extract data
              from the Site without Rightdevice's prior written consent. In addition, Rightdevice does not grant any
              express or implied rights in and to the Site, and the Rightdevice Content, and all rights in and to the
              Site and the Rightdevice Content are retained by Rightdevice. All trademarks, service marks, and logos
              displayed on the Site are the property of their respective owners, and no license is granted to use them
              without prior written permission.
            </p>
            <p>
              <b>12. RIGHTDEVICE DISCLAIMS ALL WARRANTIES</b>
            </p>
            <p>
              RIGHTDEVICE PROVIDES THE SITE, RIGHTDEVICE CONTENT AND ALL INFORMATION, MATERIALS AND OTHER CONTENT
              AVAILABLE ON THE SITE ON AN "AS IS" AND "AS AVAILABLE" BASIS "WITH ALL FAULTS." RIGHTDEVICE DISCLAIMS ALL
              WARRANTIES OF ANY KIND (WHETHER EXPRESS OR IMPLIED) AS WELL AS ANY REPRESENTATIONS, GUARANTEES, AND
              CONDITIONS RELATED TO THE SITE. WITHOUT LIMITING THE FOREGOING, TO THE FULLEST EXTENT PERMITTED BY LAW,
              RIGHTDEVICE DISCLAIMS ALL EXPRESS AND IMPLIED WARRANTIES, INCLUDING THOSE OF MERCHANTABILITY, FITNESS FOR
              A PARTICULAR PURPOSE, WORKMANLIKE EFFORT AND NON-INFRINGEMENT. RIGHTDEVICE DOES NOT REPRESENT OR WARRANT
              THAT THE SITE OR ANY ELECTRONIC COMMUNICATION FROM RIGHTDEVICE WILL BE UNINTERRUPTED, ERROR-FREE OR FREE
              OF VIRUSES OR OTHER HARMFUL COMPONENTS OR DEFECTS. RIGHTDEVICE DOES NOT WARRANT THAT ANY INFORMATION
              PROVIDED THROUGH THE SITE IS ACCURATE, COMPLETE, RELIABLE, CURRENT, OR SUITABLE FOR ANY PARTICULAR
              PURPOSE. IN ADDITION, RIGHTDEVICE EXPRESSLY DISCLAIMS ANY AND ALL RESPONSIBILITY AND LIABILITY WITH
              RESPECT TO SEPARATE AGREEMENTS YOU MAY MAKE WITH HEALTHCARE PROVIDERS OR OTHER THIRD PARTIES, AND YOU WILL
              LOOK SOLELY TO SUCH PERSONS AND/OR ENTITIES WITH RESPECT TO ANY AND ALL CLAIMS ARISING OUT OF SUCH
              AGREEMENTS. FURTHER, RIGHTDEVICE DOES NOT REPRESENT OR WARRANT THAT THE SITE OR THE CONTENT AVAILABLE ON
              THE SITE WILL ASSIST YOU IN FINDING A SUITABLE HEALTHCARE PROVIDER OR FOR ANY OTHER PURPOSE. YOU
              UNDERSTAND AND AGREE THAT YOUR USE OF THE SITE IS ENTIRELY AT YOUR OWN RISK. WHILE RIGHTDEVICE TAKES
              REASONABLE PHYSICAL, TECHNICAL, AND ADMINISTRATIVE MEASURES TO SECURE THE SITE, RIGHTDEVICE DOES NOT
              GUARANTEE THAT THE SITE CANNOT BE COMPROMISED. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN
              WARRANTIES, SO SOME OF THE ABOVE EXCLUSIONS MAY NOT APPLY TO YOU.
            </p>
            <p>
              <b>13. LIMITATION OF LIABILITY; YOUR EXCLUSIVE REMEDY</b>
            </p>
            <p>
              TO THE EXTENT PERMITTED BY LAW, IN NO EVENT WILL RIGHTDEVICE OR THE RIGHTDEVICE PARTIES BE LIABLE TO YOU
              OR TO ANY THIRD PARTY FOR ANY INDIRECT, CONSEQUENTIAL, SPECIAL, INCIDENTAL, EXEMPLARY, OR PUNITIVE DAMAGES
              (INCLUDING, BUT NOT LIMITED, TO LOSS OF PROFITS AND DAMAGES THAT RESULT FROM INCONVENIENCE, DELAY OR LOSS
              OF USE) ARISING OUT OF OR RELATING TO THE USE OF THE SITE EVEN IF RIGHTDEVICE OR ANY OF THE RIGHTDEVICE
              PARTIES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN ADDITION, IN NO EVENT SHALL RIGHTDEVICE
              BE LIABLE TO YOU OR TO ANYONE FOR ANY DECISION MADE OR ACTION TAKEN BY A PARTY (INCLUDING, WITHOUT
              LIMITATION, BY ANY USER, MENTEE, MENTOR, OR COMMUNITY MEMBER) IN RELIANCE ON ANY CONTENT OR OTHER
              INFORMATION ABOUT HEALTHCARE PROVIDERS, TREATMENTS, THERAPIES, DIAGNOSIS, CONDITIONS, OR PROCEDURES POSTED
              ON THE SITE. RIGHTDEVICE SHALL NOT BE LIABLE FOR ANY DAMAGES, DELAYS, OR NON-PERFORMANCE CAUSED BY FACTORS
              OR ACTIVITIES BEYOND ITS REASONABLE CONTROL, INCLUDING DELAYS AND NONPERFORMANCE CAUSED BY VIRUSES, DENIAL
              OF SERVICE ATTACKS, OTHER ACTS OR OMISSIONS OF THIRD PARTIES, INTERNET SERVICE PROVIDER FAILURES, STRIKES,
              LOCKOUTS, WORK SLOWDOWNS OR STOPPAGES, ACCIDENTS, FIRES, TERRORISM, ACTS OF GOD, GOVERNMENT RESTRICTIONS,
              MECHANICAL, ELECTRONIC OR COMMUNICATIONS FAILURES, WAR OR INSURRECTION. NOTWITHSTANDING ANYTHING IN THESE
              TERMS, AND TO THE EXTENT PERMITTED BY APPLICABLE LAW, THE AGGREGATE LIABILITY OF THE RIGHTDEVICE PARTIES
              TO YOU IN CONNECTION WITH THE SITE (INCLUDING ANY THIRD PARTY CONTENT ON THE SITE) AND THESE TERMS WILL BE
              LIMITED TO THE AMOUNT, IF ANY, PAID BY YOU TO RIGHTDEVICE FOR USE OF THE SITE IN THE SIX (6) MONTHS PRIOR
              TO THE ACT THAT GAVE RISE TO THE LIABILITY, EVEN IF RIGHTDEVICE HAS BEEN ADVISED OF THE POSSIBILITY OF ANY
              OF THE FOREGOING TYPES OF LOSSES OR DAMAGES. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION
              OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATIONS OR EXCLUSIONS MAY NOT APPLY TO YOU. YOUR
              SOLE AND EXCLUSIVE REMEDY FOR DISSATISFACTION WITH THE SITE IS TO STOP USING THE SITE.
            </p>
            <p>
              <b>14. Changes to the Site; Updates; Termination</b>
            </p>
            <p>
              We may change the Site or delete features available on the Site at any time and for any reason.
              Rightdevice may modify, suspend, or discontinue all or any portion of the Site at any time, with or
              without notice, and without liability to you. We are not obligated to provide maintenance, technical
              support or updates to you for the Site, but we may provide these at our discretion. We may terminate or
              suspend your Service Account and your use of the Site or any services we may provide you that are
              associated with your use of the Site at any time at our discretion. Our termination or suspension may
              occur with or without cause and with or without notice. You may terminate your use of the Site at any
              time, with or without cause, upon notice to us as specified in the customer support or "contact us" area
              on the Site. Upon termination, you may no longer use or access the Site. Upon termination, Rightdevice may
              delete or retain your information in accordance with its data retention policies and applicable law.
              Rightdevice is not obligated to maintain or provide access to your Submissions after termination. In
              addition, even if you terminate your use of the Site, Rightdevice may continue to display some or all of
              your Content.
            </p>
            <p>
              <b>15. Jurisdiction</b>
            </p>
            <p>
              Rightdevice controls and operates the Site from its offices in San Diego, California in the United States
              of America, and Rightdevice makes no representation that the Content, Content submitted by community
              members or any other content available on the Site are appropriate, available for use, or may be
              downloaded for use outside the United States. You are responsible for complying with all of your local
              laws, if and to the extent your local laws are applicable. These Terms and the Site are governed by the
              federal laws of the United States and the laws of the State of California, excluding any conflicts of law
              provisions. When you register for a Service Account and click "I accept", submit Content to the Site,
              access, browse or otherwise use the Site, this means you hereby consent to the exclusive jurisdiction of
              the state and federal courts in San Diego County, California and you waive all defenses of lack of
              personal jurisdiction and forum non convenience with respect to venue and jurisdiction in the state and
              federal courts of San Diego County, California.
            </p>
            <p>
              <b>16. Indemnification</b>
            </p>
            <p>
              To the extent permitted by applicable law, you agree to indemnify and hold harmless Rightdevice and the
              Rightdevice parties from and against any and all losses, liability, claims, demands, damages, costs and
              expenses, including reasonable attorney's fees, arising out of or in connection with: (i) any Content you
              post or submit to or through the Site; (ii) your use of the Site; (iii) your conduct in connection with
              the Site or with other users, mentees, mentors, healthcare providers, and community members of the Site;
              (iv) any breach of these Terms, other Rightdevice policies and guidelines; or (v) any violation of any law
              or the rights of any third party (including, but not limited to any violation of HIPAA or the rules, laws,
              guidelines or policies of any state medical board). Rightdevice reserves the right, at its own expense, to
              assume the exclusive defense and control of any matter otherwise subject to indemnification by you, and
              you agree to cooperate with Rightdevice in the defense of such claim. You may not settle any claim without
              Rightdevice's prior written consent if the settlement imposes any obligation or liability on Rightdevice.
            </p>
            <p>
              <b>17. Claim Must Be Filed Within One Year; Arbitration</b>
            </p>
            <p>
              Any dispute, claim, or controversy arising out of or relating to these Terms, Rightdevice, the Site, or
              the breach, termination, enforcement, interpretation or validity thereof, including the determination of
              the scope or applicability of this agreement to arbitrate, shall be determined by final and binding
              arbitration as the sole and exclusive remedy for such controversy or dispute. Any claim shall be made by
              filing a demand for arbitration within one (1) year following the event first giving rise to the claim, or
              it is permanently barred to the fullest extent permitted by law. The arbitration shall be held in San
              Diego County, California, before one arbitrator. The arbitration shall be governed by the Federal
              Arbitration Act, and the arbitration shall take place according to the rules of the American Arbitration
              Association. Judgment on the Award may be entered in any court having jurisdiction. Each of the parties
              shall bear all of its own costs of arbitration, except the fee for the arbitrator shall be equally split
              between the parties. The arbitrator shall not have the authority to modify these Terms or award punitive
              or exemplary damages to either party. This clause shall not preclude parties from seeking provisional
              remedies in aid of arbitration from a court of appropriate jurisdiction. Seeking any such remedies shall
              not constitute a waiver of either party's right to compel arbitration.
            </p>
            <p>
              CLASS ACTION WAIVER. TO THE FULLEST EXTENT PERMITTED BY LAW, YOU AND RIGHTDEVICE AGREE THAT ANY DISPUTE
              WILL BE RESOLVED ON AN INDIVIDUAL BASIS AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS,
              CONSOLIDATED, OR REPRESENTATIVE PROCEEDING. THE ARBITRATOR SHALL NOT HAVE AUTHORITY TO CONSOLIDATE CLAIMS
              OR CONDUCT A CLASS OR REPRESENTATIVE PROCEEDING.
            </p>
            <p>
              <b>18. Your Notices to Us</b>
            </p>
            <p>
              You may notify us by e-mail or postal mail. All legal notices must be sent in writing to the contact
              information provided in the "Contact Us" section of the Site or to the following address:
            </p>
            <p>
              Rightdevice, Inc. d/b/a PatientPartner
              <br />
              Attn: Legal Department
              <br />
              1025 Prospect Street, Suite 350
              <br />
              La Jolla, CA 92037 USA
              <br />
            </p>
            <p>Notices will be deemed given upon receipt.</p>
            <p>
              <b>19. Our Notices to You; Consent Regarding Electronic Communication</b>
            </p>
            <p>
              This contract is in electronic form. There may be other notices, disclosures, or other information
              regarding the Site that the law requires us to send you. You agree that we may send you this information
              in electronic form. You have the right to withdraw this consent, but if you do, we may cancel your ability
              to use the Site. We may provide required information to you via: (1) e-mail at the e-mail address you
              specified when you registered for an Account (or subsequently provided when updating your account
              information), (2) by access to a Rightdevice website that will be designated in an e-mail notice sent to
              you at the time the information is available, or (3) by access to a Rightdevice website that will be
              generally designated in advance for this purpose. Notices provided to you via e-mail will be deemed given
              and received on the transmission date of the e-mail. As long as you access and use the Site, you will have
              the necessary software and hardware to receive these notices. If you do not consent to receive any notices
              electronically, you must stop using the Site. If you want these Terms provided to you in non-electronic
              form, then please send a request to Rightdevice at contact@patientpartner.com. In that request, please
              provide your full name and address where Rightdevice can send these Terms in non-electronic form.
            </p>
            <p>
              <b>20. Miscellaneous</b>
            </p>
            <p>
              These Terms and the Mentee Consent Form (if applicable) provided to you constitute the entire agreement
              between you and Rightdevice regarding your use of the Site and your participation as Mentee under the
              PatientPartner program and supersedes any prior agreements between you and Rightdevice relating to your
              use of the Site and your participation as Mentee under the PatientPartner program. The failure of
              Rightdevice to exercise or enforce any right or provision of these Terms shall not constitute a waiver of
              such right or provision in that or any other instance. If any provision of these Terms is held invalid,
              the remainder of these Terms shall continue in full force and effect. If any provision of these Terms
              shall be deemed unlawful, void, or for any reason unenforceable, then that provision shall be deemed
              severable from these Terms and shall not affect the validity and enforceability of any remaining
              provisions. If you are a California resident, in accordance with Cal. Civ. Code §1789.3, you may report
              complaints to the Complaint Assistance Unit of the Division of Consumer Services of the California
              Department of Consumer Affairs by contacting them in writing at 400 R Street, Sacramento, CA 95814 or by
              telephone at (800) 952-5210. The following Sections survive termination of these Terms: 6 (Materials You
              Post), 11 (Intellectual Property), 12 (Disclaimers), 13 (Limitation of Liability), 15 (Jurisdiction), 16
              (Indemnification), 17 (Arbitration), and this Section 20.
            </p>
            <p>
              <b>21. DMCA Notice</b>
            </p>
            <p>
              It is Rightdevice's policy to respond to alleged copyright infringement notices that comply with the
              Digital Millennium Copyright Act of 1998 ("DMCA").
            </p>
            <p>
              If you believe that your copyrighted work has been copied in a way that constitutes copyright infringement
              and is accessible via the Site, please notify Rightdevice's copyright agent as set forth in the DMCA. For
              your complaint to be valid under the DMCA, you must provide the following information in writing:
            </p>
            <ul>
              <li>
                An electronic or physical signature of a person authorized to act on behalf of the copyright owner;
              </li>
              <li>Identification of the copyrighted work that you claim has been infringed;</li>
              <li>
                Identification of the material that is claimed to be infringing and where it is located on the Site;
              </li>
              <li>
                Information reasonably sufficient to permit Rightdevice to contact you, such as your address, telephone
                number, and e-mail address;
              </li>
              <li>
                A statement that you have a good faith belief that use of the material in the manner complained of is
                not authorized by the copyright owner, its agent, or law; and
              </li>
              <li>
                A statement, made under penalty of perjury, that the above information is accurate, and that you are the
                copyright owner or are authorized to act on behalf of the owner.
              </li>
            </ul>
            <p>The above information must be submitted to the following DMCA Agent:</p>
            <p>
              Re: DMCA Notice - Rightdevice, Inc. d/b/a PatientPartner
              <br />
              Address: Executive Counsel PLC, 2883 Macao Drive,
              <br />
              Herndon VA 20171 Attn: Nelson Blitz.
              <br />
              Tel. 703-391-1188
              <br />
              Email: nblitz@exec-counsel.com
              <br />
              <br />
            </p>
            <p>
              Under federal law, if you knowingly misrepresent that online material is infringing, you may be subject to
              criminal prosecution for perjury and civil penalties, including monetary damages, court costs, and
              attorneys' fees.
            </p>
            <p>
              Please note that this procedure is exclusively for notifying Rightdevice and its affiliates that your
              copyrighted material has been infringed. The preceding requirements are intended to comply with
              Rightdevice's rights and obligations under the DMCA, including 17 U.S.C. §512(c), but do not constitute
              legal advice. It may be advisable to contact an attorney regarding your rights and obligations under the
              DMCA and other applicable laws.
            </p>
            <p>
              In accordance with the DMCA and other applicable law, Rightdevice has adopted a policy of terminating, in
              appropriate circumstances, users who are deemed to be repeat infringers. Rightdevice may also at its sole
              discretion, limit access to the Site and/or terminate the user accounts of any users who infringe any
              Intellectual Property Rights of others, whether or not there is any repeat infringement.
            </p>

            <p>
              <b>Last updated: May 13, 2026</b>
            </p>
          </section>
        </div>
        <div className='col-sm-1'></div>
      </div>
    </div>
  );
}
